var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"charity-bar"},[_c('div',{staticClass:"copy"},[_c('div',{staticClass:"line"},[_vm._v("本购票服务仅对年满十八周岁人士开放")])])])
}]

export { render, staticRenderFns }